// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyActivateWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type { ListingAlias, UserPropertyActivateResponseWebDto } from '../..';

interface ActivateParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyActivateWebApiHandler_activate_Path = '/api/web/v1/users/properties/activate';

/**
 * Activate a property
 */
export const RentalManagerUserPropertyActivateWebApiHandler_activate = (
  getParams: ActivateParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<ActivateParams, never, UserPropertyActivateResponseWebDto>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyActivateWebApiHandler_activate_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};
